module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0119.jpg?v=a88c81d2";